module.exports = __webpack_public_path__ + "static/asona-bc6ab41d7a78c51f5bcc82b51b82341b.png";